module.exports = __webpack_public_path__ + "media/loan_payments_calculator/cal_header_02-3bd86163.png";